import { connect } from 'react-redux';
import { notifyContentModerator } from 'src/legacy/redux/actions/search.jsx';
import EmptyMessageView from './EmptyMessageView';
import _  from "lodash";

const mapStateToProps = (state, ownProps) => {
  const account = _.get(state, "accounts.item", {});
  return {
  	contentModerators: account.contentModerators
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    notifyContentModerator: (query) => {
      return dispatch(notifyContentModerator(query));
    }
  }
}

const EmptyMessageContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(EmptyMessageView);

export default EmptyMessageContainer;